export const CopyTrendCursorActionType = 'COPY_TREND_CURSOR';
export const copyNearestTrendCursor = (event, chartId) => ({
    type: CopyTrendCursorActionType,
    event,
    chartId,
});
